import Clipboard from 'clipboard'
import _ from 'lodash'
import React, { PureComponent } from 'react'
import Button from '../Button'
import Icon from '../Icon'

const successIcon = <Icon name="check-circle" color="var(--color-green-aim)" size={16} />

const failIcon = <Icon name="cross" color="var(--color-red-aim)" size={16} />

interface IClipboardButtonProps {
  text: string
  color?: string
  top?: number
}

interface IState {
  copied: '' | 'success' | 'fail'
}

export default class ClipboardButton extends PureComponent<IClipboardButtonProps, IState> {
  _clipboard?: Clipboard
  _element: any

  constructor(props: IClipboardButtonProps) {
    super(props)
    this.elRef = this.elRef.bind(this)
    this.state = {
      copied: '',
    }
  }

  componentWillUnmount() {
    this._clipboard && this._clipboard.destroy()
  }

  componentDidMount() {
    this._clipboard = new Clipboard(this._element, { text: () => this.props.text })
  }

  notifyCopy(successful: boolean) {
    this.setState({ copied: successful ? 'success' : 'fail' })

    setTimeout(() => {
      if (this._element) {
        this.setState({ copied: '' })
      }
    }, 3000)
  }

  elRef(element: any) {
    this._element = element
    if (element && this._element) {
      this._clipboard = new Clipboard(this._element, { text: () => this.props.text })
      this._clipboard.on('success', () => this.notifyCopy(true))
      this._clipboard.on('error', () => this.notifyCopy(false))
    } else {
      this._clipboard && this._clipboard.destroy()
    }
  }

  render() {
    if (!Clipboard.isSupported()) {
      return null
    }
    const { copied } = this.state
    const styles = _.isFinite(this.props.top)
      ? { position: 'relative', top: `${this.props.top}px` }
      : {}

    return (
      <span ref={this.elRef}>
        <Button variant="invisible" aria-label="Copy to Clipboard" size="auto" style={styles}>
          {copied === '' && (
            <Icon name="copy" color={this.props.color || 'var(--color-txt-muted)'} size={16} />
          )}
          {copied === 'success' && successIcon}
          {copied === 'fail' && failIcon}
        </Button>
      </span>
    )
  }
}
